import { __rest } from "tslib";
import Checkbox from 'antd/lib/checkbox';
import Icon from 'antd/lib/icon';
import React from 'react';
import Switch from 'antd/lib/switch';
import { connectField, filterDOMProps } from 'uniforms';
import wrapField from './wrapField';

var Bool = function Bool(_a) {
  var checkbox = _a.checkbox,
      props = __rest(_a, ["checkbox"]);

  return wrapField(props, React.createElement(checkbox ? Checkbox : Switch, Object.assign({
    checked: props.value,
    disabled: props.disabled,
    id: props.id,
    name: props.name,
    onChange: function onChange() {
      return props.onChange(!props.value);
    },
    ref: props.inputRef
  }, filterDOMProps(props))));
};

Bool.defaultProps = {
  checkbox: false,
  checkedChildren: React.createElement(Icon, {
    type: "check"
  }),
  unCheckedChildren: React.createElement(Icon, {
    type: "close"
  })
};
export default connectField(Bool, {
  ensureValue: false
});